import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function AjusteInventarioCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AJUSTES = process.env.REACT_APP_URL_AJUSTES;
  const URL_ARTICULOS_AJUSTE = process.env.REACT_APP_URL_ARTICULOS_AJUSTE;
  const URL_INVENTARIOS_COMBO = process.env.REACT_APP_URL_INVENTARIOS_COMBO;

  const [areas, setAreas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [motivo, setMotivo] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idArticulo: "",
      articuloNombre: "",
      colores: [],
      tallas: [],
      idColor: "",
      idTalla: "",
      idInventario: "",
      cantidadActual: 0,
      cantidadNueva: 0,
    },
  ]);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios
      .get(URL_AREAS, { headers })
      .then((res) => setAreas(res.data))
      .catch((err) => console.log(err));
    axios
      .get(URL_ARTICULOS, { headers })
      .then((res) => setArticulos(res.data))
      .catch((err) => console.log(err));
  }, []);

  // Al elegir articulo, cargamos sus colores y tallas
  function seleccionaArticulo(id, articulo) {
    if (!articulo) return;
    axios
      .get(`${URL_ARTICULOS}/${articulo._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const art = res.data;
        const nuevos = inputFields.map((i) => {
          if (id === i.id) {
            i.idArticulo = articulo._id;
            i.articuloNombre =
              (art.codigo || "") + " " + (art.descripcion || "");
            i.colores = art.colores || [];
            i.tallas = art.tallas || [];
            i.idColor = "";
            i.idTalla = "";
            i.idInventario = "";
            i.cantidadActual = 0;
          }
          return i;
        });
        setInputFields(nuevos);
      })
      .catch((err) => console.log(err));
  }

  // Busca el inventario actual del combo articulo+color+talla+area
  function buscaCombo(row) {
    if (
      selectedArea === "" ||
      row.idArticulo === "" ||
      row.idColor === "" ||
      row.idTalla === ""
    )
      return;
    axios
      .get(
        `${URL_INVENTARIOS_COMBO}/${row.idArticulo}/${row.idColor}/${row.idTalla}/${selectedArea}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((res) => {
        const inv = res.data[0];
        const nuevos = inputFields.map((i) => {
          if (row.id === i.id) {
            i.idInventario = inv ? inv._id : "";
            i.cantidadActual = inv ? inv.cantidad : 0;
          }
          return i;
        });
        setInputFields(nuevos);
      })
      .catch((err) => console.log(err));
  }

  const handleChange = (id, campo, valor) => {
    const nuevos = inputFields.map((i) => {
      if (id === i.id) i[campo] = valor;
      return i;
    });
    setInputFields(nuevos);
    if (campo === "idColor" || campo === "idTalla") {
      const row = nuevos.find((i) => i.id === id);
      buscaCombo(row);
    }
  };

  const handleAdd = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idArticulo: "",
        articuloNombre: "",
        colores: [],
        tallas: [],
        idColor: "",
        idTalla: "",
        idInventario: "",
        cantidadActual: 0,
        cantidadNueva: 0,
      },
    ]);
  };

  const handleRemove = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((v) => v.id === id),
      1
    );
    setInputFields(values);
  };

  const saveAjuste = async (event) => {
    event.preventDefault();
    // Renglones validos: articulo+color+talla elegidos
    const validos = inputFields.filter(
      (a) => a.idArticulo !== "" && a.idColor !== "" && a.idTalla !== ""
    );
    if (selectedArea === "" || motivo === "" || validos.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Faltan datos: area, motivo y al menos un articulo con color y talla.",
      });
      return;
    }
    setValidaBoton(false);
    toggleProgreso();

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    let pendientes = validos.length;
    try {
      const dataAjuste = await axios.post(
        URL_AJUSTES,
        {
          fecha,
          motivo,
          areas: selectedArea,
          user: user.id,
          total: validos.length,
        },
        { headers }
      );

      validos.forEach((a) => {
        const diferencia =
          parseFloat(a.cantidadNueva) - parseFloat(a.cantidadActual);
        axios
          .post(
            URL_ARTICULOS_AJUSTE,
            {
              ajustes: dataAjuste.data._id,
              articulos: a.idArticulo,
              colores: a.idColor,
              tallas: a.idTalla,
              areas: selectedArea,
              inventarios: a.idInventario || "",
              cantidadAnterior: parseFloat(a.cantidadActual),
              cantidad: parseFloat(a.cantidadNueva),
              diferencia,
            },
            { headers }
          )
          .then(() => {
            pendientes = pendientes - 1;
            if (pendientes === 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Ajuste de Inventario",
                    detalle: `Ajuste #${dataAjuste.data.idAjustes} - ${validos.length} articulos`,
                    user: user.id,
                  },
                  { headers }
                )
                .then(() => {
                  Swal.fire("Good job!", "Ajuste creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response ? error.response.data : ""}`,
            });
            console.log(error);
            setValidaBoton(true);
          });
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? error.response.data : ""}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajusteInventarioUser ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <h3 align="center">Ajuste de Inventario</h3>

          <Form onSubmit={saveAjuste}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Almacen / Area</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArea}
                  required
                  onChange={(e) => setSelectedArea(e.target.value)}
                >
                  <option value="">Selecciona un Area</option>
                  {areas
                    .sort((a, b) =>
                      (a.name || a.nombre) > (b.name || b.nombre) ? 1 : -1
                    )
                    .map((a) => (
                      <option value={a._id} key={a._id}>
                        {a.name || a.nombre}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={6}>
                <Label>Motivo</Label>
                <Input
                  bsSize="sm"
                  type="text"
                  value={motivo}
                  required
                  placeholder="Motivo del ajuste (conteo fisico, merma, etc.)"
                  onChange={(e) => setMotivo(e.target.value)}
                />
              </Col>
            </Row>
            <br />

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant. Actual</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant. Nueva</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Autocomplete
                      size="small"
                      value={
                        articulos.find((a) => a._id === inputField.idArticulo) ||
                        null
                      }
                      options={articulos}
                      getOptionLabel={(option) =>
                        (option.codigo || "") + " " + (option.descripcion || "")
                      }
                      onChange={(event, value) =>
                        seleccionaArticulo(inputField.id, value)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Selecciona"
                          variant="outlined"
                        />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={inputField.idColor}
                      onChange={(e) =>
                        handleChange(inputField.id, "idColor", e.target.value)
                      }
                    >
                      <option value="">Color</option>
                      {inputField.colores.map((c) => (
                        <option value={c._id} key={c._id}>
                          {c.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={inputField.idTalla}
                      onChange={(e) =>
                        handleChange(inputField.id, "idTalla", e.target.value)
                      }
                    >
                      <option value="">Talla</option>
                      {inputField.tallas.map((t) => (
                        <option value={t._id} key={t._id}>
                          {t.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={inputField.cantidadActual}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={inputField.cantidadNueva}
                      onChange={(e) =>
                        handleChange(
                          inputField.id,
                          "cantidadNueva",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemove(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAdd}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
                <br />
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar Ajuste
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar Ajuste
              </Button>
            )}
          </Form>
        </div>
      ) : undefined}

      <Modal size="sm" isOpen={modalProgreso}>
        <ModalHeader>Progreso</ModalHeader>
        <ModalBody>
          <h5 align="center">Guardando ajuste...</h5>
          <div align="center">
            <Spinner color="primary" />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default AjusteInventarioCreate;
